/***
 * 创建人：yjs
 * 时间：2019-06-13
 * 描述：只能有数字，字母，下划线组成，不能以数字开头
 * 更新记录: 
 */
import { Directive, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS } from '@angular/forms';

@Directive({
  selector: '[validatorNameNotation]',
  providers:[{provide:NG_VALIDATORS,useExisting:forwardRef(()=>ValidatorNameNotationDirective),multi:true}]
})
export class ValidatorNameNotationDirective {

  constructor() { }
  validate(control:AbstractControl):any{
    let valid:boolean = false
    var reg = /^[^0-9][A-Za-z_0-9]{0,}$/
    if(!control.value){
      valid = true  //为空时不校验
    } else{
      valid = reg.test(control.value)
    }
    return valid ? null:  {nameNotation:"只能有数字，字母，下划线组成，不能以数字开头"}   
  }
}
